module.exports = __webpack_public_path__ + "img/live_cameras-w.svg";